<div class="fieldset" [ngClass]="{'disabled' :disabled}" *ngIf="!readonly; else ro;">
    <div class="row g-1 g-md-4 datetime">
        <div #picker class="col input-group dropdown">
            <input [(ngModel)]="formattedDate" (ngModelChange)="onDateChange()" [ngModelOptions]="{updateOn: 'blur'}"
                   [required]="required" (focus)="this.focus.emit($event)" (blur)="this.blur.emit($event)" [disabled]="disabled"
                   [ngClass]="status === 'warning' ? 'warning' : status === 'error' ? 'error' : null"
                   [id]="id ? id + '-date' : null" autocomplete="off" class="form-control validatable notranslate"
                   [placeholder]="translatedPlaceholder()">
            <button class="btn btn-outline-secondary bi bi-calendar3 rounded-end"
                    data-bs-toggle="dropdown" data-bs-popper-config='{"strategy": "fixed"}' (focus)="this.focus.emit($event)" type="button" tabIndex="-1"></button>
            <div class="dropdown-menu dropdown-menu-end p-0" onclick="event.stopPropagation()">
                <app-date-picker *ngIf="showPicker" [yearSpan]="yearSpan" [date]="_calendarStartDate" [minDate]="_minDate"
                                 (dateChanged)="onDatePickerChanged($event)"></app-date-picker>
            </div>
        </div>
        <div class="col-4 time notranslate" *ngIf="!dateOnly && !hideTime">
            <app-search [(ngModel)]="time" [searchFunction]="searchTime" placeholder="hh:mm"
                        (ngModelChange)="onTimeChange($event)" [id]="id ? id + '-time' : null"
                        [required]="required" (focus)="this.focus.emit($event)" [disabled]="disabled"
                        [ngClass]="status === 'warning' ? 'warning' : status === 'error' ? 'error' : null"></app-search>
        </div>
    </div>
</div>
<ng-template #ro>
    <span [ngClass]="{'me-2 text-secondary bi bi-clock' : !dateOnly}">{{formattedDate}}</span> <span class="ms-1" *ngIf="!dateOnly">{{formattedDate | timestamp:'HH:mm'}}</span>
</ng-template>
